<template>
    <div>
  <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
   </div>

        <div class="container">
        <div class="row">
            <div class="col-lg-7">
        <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Configure item filters</h1>

  <a :href="`/#/admin/integrations/pipelines/details/${tid}/${id}`" type="button" class="btn btn-link btn-sm">
   <i class="fa fa-arrow-left" aria-hidden="true"></i>
<span>Back</span>
            </a>
       </div>
      <div class="col-lg-5 col-sm-6 text-right">
          </div>
       </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
  <!-- Connector Item Filters -->
       <div class="row mb-4">
            <div class="col-12">
        <h5>Connector Item Filters</h5>
      <p class="text-muted small">Filter items from connector data before processing</p>

         <!-- Existing Filters -->
    <div v-for="(filter, index) in connectorItemFilters" :key="'connector-' + index" class="card mb-2">
      <div class="card-body py-2 d-flex align-items-center justify-content-between">
     <div>
  <strong>{{ filter.PropertyName }}</strong>
             <span class="badge badge-secondary mx-1">{{ getOperatorLabel(filter.Operator) }}</span>
           <span v-if="filter.Value" class="text-muted">"{{ filter.Value }}"</span>
       <span class="badge" :class="filter.ExcludeMatching ? 'badge-danger' : 'badge-success'">
            {{ filter.ExcludeMatching ? 'Exclude matching' : 'Keep matching only' }}
          </span>
              </div>
     <button @click="handleRemoveConnectorItemFilter(filter)" class="btn btn-sm btn-outline-danger">
                  <i class="fa fa-trash" aria-hidden="true"></i>
       </button>
       </div>
      </div>

  <!-- Add New Filter Form -->
    <div class="card mt-3">
            <div class="card-body">
        <h6>Add Connector Filter</h6>
        <div class="form-row">
          <div class="form-group col-md-3">
          <label>Property Name</label>
           <input v-model="newConnectorFilter.propertyName" type="text" class="form-control form-control-sm" placeholder="e.g., Name, Status">
    </div>
           <div class="form-group col-md-3">
      <label>Operator</label>
      <select v-model="newConnectorFilter.operator" class="form-control form-control-sm">
        <option v-for="op in availableFilterOperators" :key="op" :value="op">{{ getOperatorLabel(op) }}</option>
              </select>
          </div>
          <div class="form-group col-md-3">
             <label>Value</label>
          <input v-model="newConnectorFilter.value" type="text" class="form-control form-control-sm" 
           :disabled="isEmptyOperator(newConnectorFilter.operator)"
    :placeholder="valuePlaceholder">
       </div>
        <div class="form-group col-md-2">
               <label>Action</label>
  <select v-model="newConnectorFilter.excludeMatching" class="form-control form-control-sm">
        <option :value="true">Exclude</option>
 <option :value="false">Keep only</option>
         </select>
        </div>
        <div class="form-group col-md-1 d-flex align-items-end">
         <button @click="handleAddConnectorItemFilter" class="btn btn-sm btn-primary">Add</button>
   </div>
  </div>
     </div>
      </div>
                </div>
            </div>

            <hr />

      <!-- Dataset Item Filters -->
            <div class="row mb-4">
     <div class="col-12">
        <h5>Dataset Item Filters</h5>
         <p class="text-muted small">Filter items from dataset data before processing</p>

<!-- Existing Filters -->
      <div v-for="(filter, index) in datasetItemFilters" :key="'dataset-' + index" class="card mb-2">
   <div class="card-body py-2 d-flex align-items-center justify-content-between">
              <div>
          <strong>{{ filter.PropertyName }}</strong>
            <span class="badge badge-secondary mx-1">{{ getOperatorLabel(filter.Operator) }}</span>
            <span v-if="filter.Value" class="text-muted">"{{ filter.Value }}"</span>
 <span class="badge" :class="filter.ExcludeMatching ? 'badge-danger' : 'badge-success'">
         {{ filter.ExcludeMatching ? 'Exclude matching' : 'Keep matching only' }}
    </span>
    </div>
   <button @click="handleRemoveDatasetItemFilter(filter)" class="btn btn-sm btn-outline-danger">
<i class="fa fa-trash" aria-hidden="true"></i>
           </button>
       </div>
         </div>

    <!-- Add New Filter Form -->
            <div class="card mt-3">
       <div class="card-body">
        <h6>Add Dataset Filter</h6>
            <div class="form-row">
         <div class="form-group col-md-3">
     <label>Property Name</label>
   <input v-model="newDatasetFilter.propertyName" type="text" class="form-control form-control-sm" placeholder="e.g., Name, Status">
           </div>
   <div class="form-group col-md-3">
      <label>Operator</label>
            <select v-model="newDatasetFilter.operator" class="form-control form-control-sm">
                    <option v-for="op in availableFilterOperators" :key="op" :value="op">{{ getOperatorLabel(op) }}</option>
 </select>
   </div>
<div class="form-group col-md-3">
           <label>Value</label>
  <input v-model="newDatasetFilter.value" type="text" class="form-control form-control-sm" 
            :disabled="isEmptyOperator(newDatasetFilter.operator)"
         :placeholder="valuePlaceholder">
        </div>
          <div class="form-group col-md-2">
    <label>Action</label>
        <select v-model="newDatasetFilter.excludeMatching" class="form-control form-control-sm">
       <option :value="true">Exclude</option>
          <option :value="false">Keep only</option>
          </select>
    </div>
            <div class="form-group col-md-1 d-flex align-items-end">
     <button @click="handleAddDatasetItemFilter" class="btn btn-sm btn-primary">Add</button>
       </div>
    </div>
</div>
         </div>
                </div>
        </div>

   <!-- Help Section -->
            <div class="row">
            <div class="col-12">
        <div class="alert alert-info">
      <h6>Filter Value Reference</h6>
     <p class="mb-1">Use <code v-pre>{{PipelineId}}</code>, <code v-pre>{{RunId}}</code>, <code v-pre>{{UserId}}</code>, or <code v-pre>{{UserEmail}}</code> for dynamic values.</p>
     <p class="mb-0">Example: Filter items where UserId equals the current user: Property=<code>UserId</code>, Operator=<code>Equals</code>, Value=<code v-pre>{{UserId}}</code></p>
       </div>
    </div>
 </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineItemFiltersPage } from '@Integrations/Pipelines/pages-core'

    document.title = "Configure item filters"

    const tid = useOrganizationUnitId()
    const id = useId()

    const valuePlaceholder = 'Value or {{UserId}}'

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useAddConnectorItemFilterCommand,
     useRemoveConnectorItemFilterCommand,
        useAddDatasetItemFilterCommand,
      useRemoveDatasetItemFilterCommand
    } = useAdminConfigurePipelineItemFiltersPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const connectorItemFilters = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorItemFilters || [])
    const datasetItemFilters = computed(() => modelPipelineDetailsQueryV1.value?.DatasetItemFilters || [])
    const availableFilterOperators = computed(() => modelPipelineDetailsQueryV1.value?.AvailableFilterOperators || [0, 1, 2, 3, 4, 5])

    // Add Connector Item Filter
    const { invokeAddConnectorItemFilterCommandV1, succeedAddConnectorItemFilterCommandV1 } = useAddConnectorItemFilterCommand(id, tid, userId)

    // Remove Connector Item Filter
    const { invokeRemoveConnectorItemFilterCommandV1, succeedRemoveConnectorItemFilterCommandV1 } = useRemoveConnectorItemFilterCommand(id, tid, userId)

    // Add Dataset Item Filter
    const { invokeAddDatasetItemFilterCommandV1, succeedAddDatasetItemFilterCommandV1 } = useAddDatasetItemFilterCommand(id, tid, userId)

    // Remove Dataset Item Filter
    const { invokeRemoveDatasetItemFilterCommandV1, succeedRemoveDatasetItemFilterCommandV1 } = useRemoveDatasetItemFilterCommand(id, tid, userId)

    // New filter forms
    const newConnectorFilter = reactive({
        propertyName: '',
    operator: 0,
  value: '',
        excludeMatching: true
    })

    const newDatasetFilter = reactive({
        propertyName: '',
        operator: 0,
     value: '',
        excludeMatching: true
    })

    const operatorLabels: Record<number, string> = {
0: 'Equals',
 1: 'Not Equals',
      2: 'Contains',
        3: 'Not Contains',
        4: 'Is Empty',
        5: 'Is Not Empty'
    }

    function getOperatorLabel(operator: number): string {
     return operatorLabels[operator] || `Operator ${operator}`
    }

    function isEmptyOperator(operator: number): boolean {
        return operator === 4 || operator === 5
    }

    function handleAddConnectorItemFilter() {
        if (!newConnectorFilter.propertyName) return
        invokeAddConnectorItemFilterCommandV1({
            PropertyName: newConnectorFilter.propertyName,
        Operator: newConnectorFilter.operator,
    Value: isEmptyOperator(newConnectorFilter.operator) ? null : newConnectorFilter.value,
        ExcludeMatching: newConnectorFilter.excludeMatching
        })
    }

    function handleRemoveConnectorItemFilter(filter: any) {
     invokeRemoveConnectorItemFilterCommandV1({
   PropertyName: filter.PropertyName,
 Operator: filter.Operator,
 Value: filter.Value,
        ExcludeMatching: filter.ExcludeMatching
        })
    }

    function handleAddDatasetItemFilter() {
        if (!newDatasetFilter.propertyName) return
        invokeAddDatasetItemFilterCommandV1({
         PropertyName: newDatasetFilter.propertyName,
            Operator: newDatasetFilter.operator,
            Value: isEmptyOperator(newDatasetFilter.operator) ? null : newDatasetFilter.value,
            ExcludeMatching: newDatasetFilter.excludeMatching
        })
    }

    function handleRemoveDatasetItemFilter(filter: any) {
      invokeRemoveDatasetItemFilterCommandV1({
        PropertyName: filter.PropertyName,
  Operator: filter.Operator,
            Value: filter.Value,
            ExcludeMatching: filter.ExcludeMatching
        })
    }

    onMounted(() => {
 runCurrentUserQueryV1()
  runPipelineDetailsQueryV1()
    })

  // Refresh data after commands succeed
    watch([
        succeedAddConnectorItemFilterCommandV1,
 succeedRemoveConnectorItemFilterCommandV1,
  succeedAddDatasetItemFilterCommandV1,
        succeedRemoveDatasetItemFilterCommandV1
    ], () => {
    runPipelineDetailsQueryV1()
        // Reset forms
        newConnectorFilter.propertyName = ''
    newConnectorFilter.value = ''
 newDatasetFilter.propertyName = ''
     newDatasetFilter.value = ''
    })
</script>
